import { PurchaseOrderStatus } from 'src/models/enums/PurchaseOrderStatus.enum';
import { userRoles } from './properties.utils';

export interface PurchaseOrderPermissions {
  canView: boolean;
  canEdit: boolean;
  canUpdateStatus: boolean;
  canDelete: boolean;
  canCreateGRN: boolean;
  canPrint: boolean;
}

export const getPurchaseOrderPermissions = (
  userRole: string,
  status: PurchaseOrderStatus
): PurchaseOrderPermissions => {
  const normalizedRole = userRole?.toLowerCase()?.trim() || '';

  const isAdminOrOwner =
    normalizedRole === userRoles.ADMIN.toLowerCase() ||
    normalizedRole === userRoles.OWNER.toLowerCase();
  const isFactoryManagerOrExecutive =
    normalizedRole === userRoles.FACTORY_MANAGER.toLowerCase() ||
    normalizedRole === userRoles.EXECUTIVE.toLowerCase();

  const canEdit =
    (isAdminOrOwner || isFactoryManagerOrExecutive) &&
    (status === PurchaseOrderStatus.NEW ||
      status === PurchaseOrderStatus.PENDING);

  const canDelete =
    status === PurchaseOrderStatus.NEW ||
    status === PurchaseOrderStatus.PENDING;

  const canPrint =
    (isAdminOrOwner || isFactoryManagerOrExecutive) &&
    (status === PurchaseOrderStatus.APPROVED ||
      status === PurchaseOrderStatus.REJECTED);

  const permissions = {
    canView: true,
    canEdit,
    canUpdateStatus: isAdminOrOwner && status === PurchaseOrderStatus.PENDING,
    canDelete,
    canCreateGRN: isAdminOrOwner && status === PurchaseOrderStatus.APPROVED,
    canPrint,
  };

  return permissions;
};
